/**
 * O contador da mesa (E78.F4), desde a E162.F2.T02 só do que pede conclusão (ADR-0111 §2.1): as
 * CCBs com a conclusão do assistente registrada. E180.F2 (GUS-254, ADR-0133): a conclusão é
 * facultativa — o contador informa, não diz o que falta para liberar.
 */
import { ptBR } from '@/i18n/pt-BR';
import {
  exigeConclusao,
  pecaConcluida,
  type ExameEletronicoCcbData,
} from '@/lib/exame_eletronico_ccb';

const t = ptBR.mesaEletronica;

export function contadorDasCcbs(pecas: readonly ExameEletronicoCcbData[]): string {
  const aConcluir = pecas.filter(exigeConclusao);
  const concluidas = aConcluir.filter(pecaConcluida).length;
  const contador = t.contador
    .replace('{concluidas}', String(concluidas))
    .replace('{total}', String(aConcluir.length));
  return concluidas === aConcluir.length ? contador : `${contador} · ${t.contadorPeloSistema}`;
}
